/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Admin Console
 * Mercatus Admin Console
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * NavbarApi - axios parameter creator
 * @export
 */
export const NavbarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Clears the organization navigation bar logo.
         * @summary Delete organization navigation bar logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNavbarLogo: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navbar/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the organization navigation bar logo image bytes. Responds with 404 when no logo is configured. 
         * @summary Get organization navigation bar logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavbarLogo: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navbar/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts a single multipart file field named \"file\". Allowed types are PNG, JPG/JPEG, GIF, and WebP. Maximum size is 100 MB (server). 
         * @summary Upload or replace organization navigation bar logo
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putNavbarLogo: async (file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('putNavbarLogo', 'file', file)
            const localVarPath = `/navbar/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NavbarApi - functional programming interface
 * @export
 */
export const NavbarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NavbarApiAxiosParamCreator(configuration)
    return {
        /**
         * Clears the organization navigation bar logo.
         * @summary Delete organization navigation bar logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNavbarLogo(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNavbarLogo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the organization navigation bar logo image bytes. Responds with 404 when no logo is configured. 
         * @summary Get organization navigation bar logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNavbarLogo(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNavbarLogo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Accepts a single multipart file field named \"file\". Allowed types are PNG, JPG/JPEG, GIF, and WebP. Maximum size is 100 MB (server). 
         * @summary Upload or replace organization navigation bar logo
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putNavbarLogo(file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putNavbarLogo(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NavbarApi - factory interface
 * @export
 */
export const NavbarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NavbarApiFp(configuration)
    return {
        /**
         * Clears the organization navigation bar logo.
         * @summary Delete organization navigation bar logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNavbarLogo(options?: any): AxiosPromise<void> {
            return localVarFp.deleteNavbarLogo(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the organization navigation bar logo image bytes. Responds with 404 when no logo is configured. 
         * @summary Get organization navigation bar logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavbarLogo(options?: any): AxiosPromise<any> {
            return localVarFp.getNavbarLogo(options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts a single multipart file field named \"file\". Allowed types are PNG, JPG/JPEG, GIF, and WebP. Maximum size is 100 MB (server). 
         * @summary Upload or replace organization navigation bar logo
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putNavbarLogo(file: any, options?: any): AxiosPromise<void> {
            return localVarFp.putNavbarLogo(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NavbarApi - object-oriented interface
 * @export
 * @class NavbarApi
 * @extends {BaseAPI}
 */
export class NavbarApi extends BaseAPI {
    /**
     * Clears the organization navigation bar logo.
     * @summary Delete organization navigation bar logo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavbarApi
     */
    public deleteNavbarLogo(options?: any) {
        return NavbarApiFp(this.configuration).deleteNavbarLogo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the organization navigation bar logo image bytes. Responds with 404 when no logo is configured. 
     * @summary Get organization navigation bar logo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavbarApi
     */
    public getNavbarLogo(options?: any) {
        return NavbarApiFp(this.configuration).getNavbarLogo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts a single multipart file field named \"file\". Allowed types are PNG, JPG/JPEG, GIF, and WebP. Maximum size is 100 MB (server). 
     * @summary Upload or replace organization navigation bar logo
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavbarApi
     */
    public putNavbarLogo(file: any, options?: any) {
        return NavbarApiFp(this.configuration).putNavbarLogo(file, options).then((request) => request(this.axios, this.basePath));
    }
}
